import router from './router'
import store from './store'

router.beforeEach((to, _from, next) => {
  const language = to.params.language
  if (language && language !== store.state.location.language) {
    store.dispatch('location/setLanguage', { language })
  }

  const country = to.params.country
  if (country && country !== store.state.location.country) {
    store.dispatch('location/setCountry', { countryCode: country })
  }

  next()
})
